/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import Modal from '../design/shared/modal';
import { customStyles } from './css';

import UpdateOrder from './updateOrder';
import OrderComments from './orderComments';
import Note from '../note';
import FormSummaryGroup from '../form/formSummaryGroup';

const OrderDetails = ({
  open,
  setOpen,
  order,
  onSave,
  userRights,
  assignees,
  comments,
  staticLabels,
  summary
}) => {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      order={order}
      customStyles={customStyles}
    >
      <div className="container 85%">
        <UpdateOrder
          orderStatus={order.status}
          sovStatus={order.sovStatus}
          order={order}
          setOpen={setOpen}
          open={open}
          onSave={onSave}
          users={assignees}
          assignedUserId={order.assignedUserId}
          userRights={userRights}
          labels={staticLabels}
        >
          <ExpandCollapse>
            {summary &&
              summary.map(({ fields }) => {
                const { note, formSummaryGroup, title } = fields;
                return (
                  <ExpandCollapse.Panel key={title} id={title} header={title}>
                    <>
                      {note && note.content && (
                        <Note data={note} type="richText" />
                      )}
                      <FormSummaryGroup
                        data={formSummaryGroup}
                        orderData={order}
                      />
                    </>
                  </ExpandCollapse.Panel>
                );
              })}
          </ExpandCollapse>
          {OrderComments(comments)}
        </UpdateOrder>
      </div>
    </Modal>
  );
};

OrderDetails.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  userRights: PropTypes.object.isRequired,
  comments: PropTypes.object.isRequired,
  assignees: PropTypes.object.isRequired,
  staticLabels: PropTypes.object.isRequired,
  summary: PropTypes.object.isRequired
};
export default OrderDetails;
